<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container">
	<lgb-comming-soon></lgb-comming-soon>
</div>